<script lang="ts">
	import "../app.css";

	import { afterNavigate, beforeNavigate } from "$app/navigation";
	import { updated } from "$app/state";
	import { Toaster } from "svelte-sonner";
	import type { LayoutProps } from "./$types";

	let { children }: LayoutProps = $props();

	beforeNavigate(({ willUnload, to, type, cancel, shallow }) => {
		if (shallow) return;

		if (updated.current && !willUnload && to?.url && type !== "popstate") {
			cancel();
			const sameDocument =
				to.url.origin === location.origin &&
				to.url.pathname === location.pathname &&
				to.url.search === location.search;
			location.href = to.url.href;
			if (sameDocument && to.url.href.includes("#")) location.reload();
		}
	});

	afterNavigate(({ type, shallow }) => {
		if (shallow) return;
		if (updated.current && type === "popstate") location.reload();
	});
</script>

<Toaster />
{@render children?.()}
